import { localStorageSupported } from '$lib/helper/browser';
import { DeviceType, guessDeviceType } from '$lib/helper/device';
import { doNotDisturbStore } from '$lib/stores/doNotDisturb';

export function getAvailableSounds() {
	return [
		'default',
		'chime',
		'cat',
		'bell',
		'cashmachine',
		'coins',
		'laser',
		'down',
		'valid',
		'fail',
		'yay',
		'none'
	];
}

export const isSoundAllowed = () => {
	if (!localStorageSupported()) {
		return false;
	}

	if (doNotDisturbStore.isActive()) {
		return false;
	}

	// Do not play sounds on mobile devices
	if (guessDeviceType() === DeviceType.Mobile) {
		return false;
	}

	// If the settings does not exist, sound is allowed by default
	if (localStorage.getItem('muted') === null) {
		localStorage.setItem('muted', 'false');
	}

	return localStorage.getItem('muted') === 'false';
};

let soundsCached: Record<string, Audio> = {};
export const playSound = (sound: string, ignoreMute: boolean = false): Promise<void> => {
	if (!sound || sound === 'none') {
		return Promise.resolve();
	}

	if (!isSoundAllowed() && !ignoreMute) {
		return Promise.resolve();
	}

	if (!soundsCached[sound]) {
		soundsCached[sound] = new Audio(`/sounds/${sound}.mp3`);
	}

	const audio = soundsCached[sound];
	if (audio && !audio.paused) {
		audio.currentTime = 0; // Remise à zéro de l'audio
	}
	return audio.play();
};
